export const updateCount = (input, counter, maxLength) => {
    if (!input || !counter) return;

    const currentLength = input.value ? input.value.length : 0;
    counter.textContent = `${currentLength}/${maxLength}`;

    if (currentLength > maxLength) {
        counter.classList.add('limit-reached');
    } else {
        counter.classList.remove('limit-reached');
    }
};

export const setupCharacterCount = (inputId, counterId, maxLength) => {
    const input = document.getElementById(inputId);
    const counter = document.getElementById(counterId);

    if (!input || !counter) return;

    updateCount(input, counter, maxLength);

    input.addEventListener('input', () => {
        updateCount(input, counter, maxLength);
    });
};

export const validation = {
    updateCount,
    setupCharacterCount,
};
